import React from "react";

function LeftActive() {
  return (
    <svg
      width="10"
      height="16"
      viewBox="0 0 10 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.4375 1.75L1.5625 8L8.4375 14.25"
        stroke="#555555"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default LeftActive;
